import React from 'react';

const FlagIcon = (props) => (
  <svg
    width={14}
    height={18}
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.13469 13.8146V2.56457C3.13469 2.33445 3.32124 2.1479 3.55136 2.1479C3.78148 2.1479 3.96803 2.33445 3.96803 2.56457L3.96803 10.0646L3.96803 13.8146H3.13469ZM3.55136 0.897903C4.47183 0.897903 5.21803 1.6441 5.21803 2.56457H12.7895C13.5319 2.56457 13.9037 3.46219 13.3788 3.98716L11.0514 6.31457L13.3788 8.64198C13.9037 9.16695 13.5319 10.0646 12.7895 10.0646H5.21803V13.8206C6.07467 13.89 6.74823 14.6072 6.74823 15.4817V15.6874C6.74823 16.6079 6.00204 17.354 5.08156 17.354H2.04216C1.12169 17.354 0.375496 16.6079 0.375496 15.6874L0.375496 15.4817C0.375496 14.6144 1.03807 13.9018 1.88469 13.8224V2.56457C1.88469 1.6441 2.63088 0.897903 3.55136 0.897903ZM5.21803 8.81457V3.81457H11.7836L9.28359 6.31457L11.7836 8.81457H5.21803ZM1.6255 15.4817V15.6874C1.6255 15.9175 1.81204 16.104 2.04216 16.104H5.08156C5.31168 16.104 5.49823 15.9175 5.49823 15.6874V15.4817C5.49823 15.2516 5.31168 15.0651 5.08156 15.0651H2.04216C1.81204 15.0651 1.6255 15.2516 1.6255 15.4817Z"
      fill={props.fill || '#153142'}
    />
  </svg>
);
export default FlagIcon;
